import _ from 'lodash';

const POPUP_START_KEY = 'newsletterPopupStartTime';
const POPUP_SHOWN_KEY = 'newsletterPopupShown';

// Get the popup start time (set on first page of session)
export const GetPopupStartTime = (): number => {
  const stored = sessionStorage.getItem(POPUP_START_KEY);
  return stored ? parseInt(stored, 10) : 0;
};

export const SetPopupStartTime = (): void => {
  if (!sessionStorage.getItem(POPUP_START_KEY)) {
    sessionStorage.setItem(POPUP_START_KEY, Date.now().toString());
  }
};

export const GetSessionPopupShown = (): boolean => {
  return sessionStorage.getItem(POPUP_SHOWN_KEY) === 'true';
};

export const SetSessionPopupShown = (): void => {
  sessionStorage.setItem(POPUP_SHOWN_KEY, 'true');
};

export const GetSessionIntentHide = (): number => {
  const sessionIntentHide = sessionStorage.getItem('sessionIntentHide');
  return sessionIntentHide ? _.parseInt(sessionIntentHide) : 0;
};

export const SetSessionIntentHide = (): void => {
  sessionStorage.setItem('sessionIntentHide', '1');
};

export const GetLocalHasSubscribed = (): number => {
  const hasSubscribed = localStorage.getItem('hasSubscribed');
  return hasSubscribed ? _.parseInt(hasSubscribed) : 0;
};

export const SetLocalHasSubscribed = (): void => {
  localStorage.setItem('hasSubscribed', '1');
};
